<template>
  <el-row class="login-header" align="middle">
    <el-col :span="20">
      <img class="logo" alt="Vue logo" src="../../assets/images/logo_pixeon.png">
    </el-col>
    <el-col v-show="!showLoginButton" :span="4">
      <router-link to="/auth" title="Login">
        <el-button round class="color-gray">Login</el-button>
      </router-link>
    </el-col>
  </el-row>
</template>

<script>
import { useRoute } from 'vue-router'
import { computed } from 'vue'

export default {
  name: 'LoginHeader',
  setup () {
    const route = useRoute()
    const showLoginButton = computed(() => route.path === '/auth')

    return {
      showLoginButton
    }
  }
}
</script>

<style lang="scss">
@import "~@/styles/variables.scss";

.color-gray {
  span {
    color: $gray;
  }

}

.login-header {
  padding: 45px 140px 30px;
}

.logo {
  max-height: 54px;
}
</style>>
